export const PATH_URL = {
    HOME_PAGE_URL: '/pgmlist',
}